//scenarioCatalogue FilterAction Types
export const scenarioCatalogueFilterTypes = ()=>{
		return{
			addFilter:"ADD_FILTER",
			removeFilter:"REMOVE_FILTER",
			clearFilters: "CLEAR_FILTERS"
			
		}
}

//scenarioCatalogue dashboardAction Types
export const scenarioCataloguedashboardActions = ()=>{
		return{
			passengerState:"SET_PASSENGER_STATE",
			commercialState:"SET_COMMERCIAL_STATE"		
		}
}


//scenarioCatalogue ViewAction Types
export const scenarioCatalogueViewTypes = ()=>{
		return{
			addScenarioData:"ADD_SCENARIO_CATALOGUE_DATA_FROM_API"
		}
}

//addChartValues Action Types
// export const addChartValuesTypes = ()=>{
// 		return{
// 			updateID: "UPDATED_ID",
// 			updateKPIStatus: "UPDATE_KPI_STATUS"
// 		}
// }

//addToCartAction Types
export const addToCartTypes = ()=>{
		return{
			addItems:"ADD_ITEMS",
			addBaseItems:"ADD_BASE_ITEMS",
			getADClients:"GET_AD_CLIENTS",
			addGroup:"ADD_GROUP",
			updateCart:"UPDATE_CART"
		}
}

//scenarioGroupAction Types
export const scenarioGroupActionTypes = ()=>{
		return{
			addScenario:"ADD_SCENARIO_GROUP_FROM_API",
			editScenario:"EDIT_SCENARIO_GROUP",
			deleteScenario:	"DELETE_SCENARIO_GROUP"
		}
}

//scenarioManagerAction Types
export const scenarioManagerTypes = ()=>{
		return{	
			addScenarioManager:"ADD_SCENARIO_MANAGER_FROM_API"
		}
}

//scenarioTestTable Action Types

export const scenarioTestTableActions = ()=>{
		return{	
			addTestData:"ADD_TEST_DATA_FROM_API",
			editTestData:"EDIT_TEST_DATA",
			deleteTestdata:"DELETE_TEST_DATA"
			
		}
}

//testRunstatus Action Types

export const testRunStatusAction = ()=>{
		return{
			addTestRunStatus:"ADD_TESTRUN_STATUS_FROM_API"
		}
}

// scenarioFileUpload Action Types
export const scenarioFileUpload = () => {
    return {
        SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
        SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
        SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
        FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE'
    }
}

export const scenarioFileUploadEnhanced = () => {
    return {
        SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
        SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
        SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
        FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE',
        RESET_UPLOAD_FILE: 'RESET_UPLOAD_FILE'
    }
}

export const cmScenarioFileUploadEnhanced = () => {
    return {
        SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
        SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
        SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
        FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE',
        RESET_UPLOAD_FILE: 'RESET_UPLOAD_FILE'
    }
}
// scenarioVariationUpload Action Types
export const scenarioVariationUpload = () => {
    return {
        SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
        SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
        SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
        FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE'
    }
}

// SelectTopologyDropDown Action Types
export const selectedTopology = () => {
    return {
        TOPOLOGY_NAME: 'TOPOLOGY_NAME',
        TOPOLOGY_UUID: 'TOPOLOGY_UUID',
    }
}


//Binding Icons with openloop PR labelled data
export const bindIconForPRLabelledData = {
	//bad_road_conditions --> all are there -> done mapping
	// bad_road_conditions: "images/PR_labelled_data_icons/bad_road_conditions/bad_road_conditions.bmp",
	// intersection: "images/PR_labelled_data_icons/bad_road_conditions/intersection.bmp",
	// rail_of_street_car: "images/PR_labelled_data_icons/bad_road_conditions/rail_of_streetcar.bmp",
	// grade_crossing: "images/PR_labelled_data_icons/bad_road_conditions/grade_crossing.bmp",
	// blinker_light: "images/PR_labelled_data_icons/bad_road_conditions/blinker_light.bmp",
	// bicycle: "images/PR_labelled_data_icons/bad_road_conditions/bicycle.bmp",
	// long_vehicles: "images/PR_labelled_data_icons/bad_road_conditions/long_vehicles.bmp",
	// road_merging: "images/PR_labelled_data_icons/bad_road_conditions/road_merging.bmp",

	// behavior --> icons are there 
	// adjacent_vehicle_offset_to_own_lane: "images/PR_labelled_data_icons/behavior/adjacent_vehicle_offset_to_own_lane.bmp", 
    // cutting_into_the_adjacent_lane: "images/PR_labelled_data_icons/behavior/cutting_into_the_adjacent_lane.bmp",
	cut_in: "images/PR_labelled_data_icons/behavior/cut_in.bmp",
    cut_out: "images/PR_labelled_data_icons/behavior/cut_out.bmp",
    crossing_scenarios: "images/PR_labelled_data_icons/behavior/crossing_scenarios.bmp",
    car_following: "images/PR_labelled_data_icons/behavior/car_following.bmp",
    overtaking: "images/PR_labelled_data_icons/behavior/overtaking.bmp",
    passing: "images/PR_labelled_data_icons/behavior/passing.bmp",
    running_parallel_to_the_car_in_front_of_you: "images/PR_labelled_data_icons/behavior/running_parallel_to_the_car_in_front_of_you.bmp",
    vehicle_in_front_turning_left_right: "images/PR_labelled_data_icons/behavior/vehicle_in_front_turning_left_right.bmp",
    // other_behavior: "images/PR_labelled_data_icons/behavior/other_behavior.bmp",


	// day_time --> done  --> icons are there 
	day: "images/PR_labelled_data_icons/day_time/day.bmp",
	dusk_dawn: "images/PR_labelled_data_icons/day_time/dusk_dawn.bmp",
	night: "images/PR_labelled_data_icons/day_time/night.bmp",

	// degree --> done --> icons are there 
	quickly: "images/PR_labelled_data_icons/degree/quickly.bmp",
    slowly: "images/PR_labelled_data_icons/degree/slowly.bmp",

	// driving_lane --> icon missing --> 
	// one_lane_driving_lane: "images/PR_labelled_data_icons/driving_lane/quickly.bmp",

	// ego_vehicle_behavior --> done
	leading_stop_at_intersection: "images/PR_labelled_data_icons/ego_vehicle_behavior/leading_stop_at_intersection.bmp",
	distant_stop: "images/PR_labelled_data_icons/ego_vehicle_behavior/distant_stop.bmp",
	right_lane_change_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/right_lane_change_ego_vehicle.bmp",
	left_lane_change_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/left_lane_change_ego_vehicle.bmp",
	turn_right_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/turn_right_ego_vehicle.bmp",
	turn_left_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/turn_left_ego_vehicle.bmp",
	overtaking_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/overtaking_ego_vehicle.bmp",
	passing_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/passing_ego_vehicle.bmp",
	// other_behavior_ego_vehicle: "images/PR_labelled_data_icons/ego_vehicle_behavior/other_behavior_ego_vehicle.bmp",
	

	// free_conditions --> done
	// hotspot: "images/PR_labelled_data_icons/free_conditions/hotspot.bmp",
	// unexpected_situations:"images/PR_labelled_data_icons/free_conditions/unexpected_situations.bmp",
	// others: "images/PR_labelled_data_icons/free_conditions/others.bmp",
	// another_lane_parallel_overlap: "images/PR_labelled_data_icons/free_conditions/another_lane_parallel_overlap.bmp",
	// bulges: "images/PR_labelled_data_icons/free_conditions/bulges.bmp",
	// carpool_lane: "images/PR_labelled_data_icons/free_conditions/turn_right_ego_vehicle.bmp",
	// delivery_bike: "images/PR_labelled_data_icons/free_conditions/delivery_bike.bmp",
	// group_motorcycle_2_or_more: "images/PR_labelled_data_icons/free_conditions/group_motorcycle_2_or_more.bmp",
	// guard_rail_with_reflectors_at_corners_curves_red_colour_white_colour: "images/PR_labelled_data_icons/free_conditions/guard_rail_with_reflectors_at_corners_curves_red_colour_white_colour.bmp",
	// highway_exits: "images/PR_labelled_data_icons/free_conditions/highway_exits.bmp",
	// highway_jp_road: "images/PR_labelled_data_icons/free_conditions/highway_jp_road.bmp",
	// light_truck: "images/PR_labelled_data_icons/free_conditions/light_truck.bmp",
	// low_floor_trailer: "images/PR_labelled_data_icons/free_conditions/low_floor_trailer.bmp",
	// pavement_marker_reflector: "images/PR_labelled_data_icons/free_conditions/pavement_marker_reflector.bmp",
	// ramp_fork: "images/PR_labelled_data_icons/free_conditions/ramp_fork.bmp",
	// ramp_jct_ic: "images/PR_labelled_data_icons/free_conditions/ramp_jct_ic.bmp",
	// reversible_lane_zipper_lane: "images/PR_labelled_data_icons/free_conditions/reversible_lane_zipper_lane.bmp",
	// rubber_pole_cushion_drum: "images/PR_labelled_data_icons/free_conditions/rubber_pole_cushion_drum.bmp",
	// sa_pa: "images/PR_labelled_data_icons/free_conditions/sa_pa.bmp",
	// sidecar: "images/PR_labelled_data_icons/free_conditions/sidecar.bmp",
	// sound_insulation_wall: "images/PR_labelled_data_icons/free_conditions/sound_insulation_wall.bmp",
	// specified_road_sign: "images/PR_labelled_data_icons/free_conditions/specified_road_sign.bmp",
	// speed_bump: "images/PR_labelled_data_icons/free_conditions/speed_bump.bmp",
	// taillamp_embedded: "images/PR_labelled_data_icons/free_conditions/taillamp_embedded.bmp",
	// tow_vehicle: "images/PR_labelled_data_icons/free_conditions/tow_vehicle.bmp",
	// vehicle_with_spare_tire: "images/PR_labelled_data_icons/free_conditions/vehicle_with_spare_tire.bmp",


	// heavy_sun_glaring --> done
	sunlight_heavy: "images/PR_labelled_data_icons/heavy_sun_glaring/heavy.bmp",
	sunlight_light: "images/PR_labelled_data_icons/heavy_sun_glaring/light.bmp",
	sunlight_none: "images/PR_labelled_data_icons/heavy_sun_glaring/none.bmp",

	// hotspot
	// construction_section: "images/PR_labelled_data_icons/hotspot/construction_section.bmp",
	// metal_bridge: "images/PR_labelled_data_icons/hotspot/metal_bridge.bmp",
	// metal_plate: "images/PR_labelled_data_icons/hotspot/metal_plate.bmp",
	// pedestrian: "images/PR_labelled_data_icons/hotspot/pedestrian.bmp",
	// roundabout: "images/PR_labelled_data_icons/hotspot/roundabout.bmp",
	// special_vehicle: "images/PR_labelled_data_icons/hotspot/special_vehicle.bmp",
	// under_pass: "images/PR_labelled_data_icons/hotspot/under_pass.bmp",

	//road_surface --> icons not available --> all done
	// white_line_color: "images/PR_labelled_data_icons/road_surface/white_line_color.bmp",
	// yellow_line_color: "images/PR_labelled_data_icons/road_surface/yellow_line_color.bmp",
	// others_line_color: "images/PR_labelled_data_icons/road_surface/others_line_color.bmp",
	// none_line_shape: "images/PR_labelled_data_icons/road_surface/none_line_shape.bmp",
	// solid_line_line_shape: "images/PR_labelled_data_icons/road_surface/solid_line_line_shape.bmp",
	// dotted_line_line_shape: "images/PR_labelled_data_icons/road_surface/dotted_line_line_shape.bmp",
	// multiple_lines_double_more_than_triple_line_shape: "images/PR_labelled_data_icons/road_surface/multiple_lines_double_more_than_triple_line_shape.bmp",
	// rubbing_line_disappearing_line_shape: "images/PR_labelled_data_icons/road_surface/rubbing_line_disappearing_line_shape.bmp",
	// redraw_line_shape: "images/PR_labelled_data_icons/road_surface/redraw_line_shape.bmp",
	// potts_dots_line_shape: "images/PR_labelled_data_icons/road_surface/potts_dots_line_shape.bmp",
	// zebra_zone_line_shape: "images/PR_labelled_data_icons/road_surface/zebra_zone_line_shape.bmp",
	// others_line_shape: "images/PR_labelled_data_icons/road_surface/others_line_shape.bmp",
	// ice_management_lines: "images/PR_labelled_data_icons/road_surface/ice_management_lines.bmp",
	

	//road_type --> motorway_us_eu_road --> icon missing
	city_us_eu_road: "images/PR_labelled_data_icons/road_type/city_us_eu_road.bmp",
	country_road_us_eu_road: "images/PR_labelled_data_icons/road_type/country_road_us_eu_road.bmp",
	// motorway_us_eu_road: "images/PR_labelled_data_icons/road_type/motorway_us_eu_road.bmp",

	//street_conditions --> done
	dry: "images/PR_labelled_data_icons/street_conditions/dry.bmp",
	snow_ice: "images/PR_labelled_data_icons/street_conditions/snow_ice.bmp",
	wet: "images/PR_labelled_data_icons/street_conditions/wet.bmp",

	//unexpected_situations
	long_slope: "images/PR_labelled_data_icons/unexpected_situations/long_slope.bmp",
	monorail: "images/PR_labelled_data_icons/unexpected_situations/monorail.bmp",
	sharp_curve_with_sign_r: "images/PR_labelled_data_icons/unexpected_situations/sharp_curve_with_sign_r.bmp",
	stacked_roads: "images/PR_labelled_data_icons/unexpected_situations/stacked_roads.bmp",
	street_parking: "images/PR_labelled_data_icons/unexpected_situations/street_parking.bmp",
	traffic_jam: "images/PR_labelled_data_icons/unexpected_situations/traffic_jam.bmp",
	trike: "images/PR_labelled_data_icons/unexpected_situations/trike.bmp",
	tunnel: "images/PR_labelled_data_icons/unexpected_situations/tunnel.bmp",

	//weather_conditions --> done
	sun: "images/PR_labelled_data_icons/weather_conditions/sun.bmp",
	overcast: "images/PR_labelled_data_icons/weather_conditions/overcast.bmp",
	rain_light: "images/PR_labelled_data_icons/weather_conditions/rain_light.bmp",
	rain_strong: "images/PR_labelled_data_icons/weather_conditions/rain_strong.bmp",
	snow: "images/PR_labelled_data_icons/weather_conditions/snow.bmp",
	fog: "images/PR_labelled_data_icons/weather_conditions/fog.bmp",
	hail: "images/PR_labelled_data_icons/weather_conditions/hail.bmp",
	//road_situation  --> all sone --> missing 
	// construction_section: "images/PR_labelled_data_icons/road_situation/construction_section.bmp",
	// highway_exits: "images/PR_labelled_data_icons/road_situation/highway_exits.bmp",
	// highway_jp_road: "images/PR_labelled_data_icons/road_situation/highway_jp_road.bmp",
	// traffic_jam: "images/PR_labelled_data_icons/road_situation/traffic_jam.bmp",
	// concrete_lane_cobblestone_lane: "images/PR_labelled_data_icons/road_situation/concrete_lane_cobblestone_lane.bmp",
	// intersection:"images/PR_labelled_data_icons/road_infrastructure/intersection.bmp",
	// bad_road_conditions: "images/PR_labelled_data_icons/road_situation/bad_road_conditions.bmp",
	// toll_station_country_border: "images/PR_labelled_data_icons/road_situation/toll_station.bmp",
	// waterway: "images/PR_labelled_data_icons/road_situation/waterway.bmp",
	// country_border: "images/PR_labelled_data_icons/road_situation/country_border.bmp",

	// road_infrastructure --> done
	long_slope: "images/PR_labelled_data_icons/road_infrastructure/long_slope.bmp",
	sa_pa: "images/PR_labelled_data_icons/road_infrastructure/sa_pa.bmp",
	ramp_jct_ic: "images/PR_labelled_data_icons/road_infrastructure/ramp_jct_ic.bmp",
	another_lane_parallel_overlap: "images/PR_labelled_data_icons/road_infrastructure/another_lane_parallel_overlap.bmp",
	roundabout: "images/PR_labelled_data_icons/road_infrastructure/roundabout.bmp",
	stacked_roads: "images/PR_labelled_data_icons/road_infrastructure/stacked_roads.bmp",
	ramp_fork: "images/PR_labelled_data_icons/road_infrastructure/ramp_fork.bmp",
	narrow_angle_fork:"images/PR_labelled_data_icons/road_infrastructure/narrow_angle_fork.bmp",
	reversible_lane_zipper_lane: "images/PR_labelled_data_icons/road_infrastructure/reversible_lane_zipper_lane.bmp",
	under_pass: "images/PR_labelled_data_icons/road_infrastructure/under_pass.bmp",
	sharp_curve_with_sign_r: "images/PR_labelled_data_icons/road_infrastructure/sharp_curve_with_sign_r.bmp",
	carpool_lane: "images/PR_labelled_data_icons/road_infrastructure/carpool_lane.bmp",
	bulges: "images/PR_labelled_data_icons/road_infrastructure/bulges.bmp",
	// metal_bridge: "images/PR_labelled_data_icons/road_infrastructure/metal_bridge.bmp",
	tunnel: "images/PR_labelled_data_icons/road_infrastructure/tunnel.bmp",
	road_merging: "images/PR_labelled_data_icons/road_infrastructure/road_merging.bmp",
	// intersection:"images/PR_labelled_data_icons/road_infrastructure/intersection.bmp",
	// concrete_lane: "images/PR_labelled_data_icons/road_infrastructure/concrete_lane.bmp" ,
	// cobblestone_lane: "images/PR_labelled_data_icons/road_infrastructure/cobblestone_lane.bmp",

	//road_sign_or_obstruction  --> all done
	rubber_pole_cushion_drum: "images/PR_labelled_data_icons/road_sign_or_obstruction/rubber_pole_cushion_drum.bmp",
	// sound_insulation_wall: "images/PR_labelled_data_icons/road_sign_or_obstruction/sound_insulation_wall.bmp",
	specified_road_sign: "images/PR_labelled_data_icons/road_sign_or_obstruction/specified_road_sign.bmp",
	speed_bump: "images/PR_labelled_data_icons/road_sign_or_obstruction/speed_bump.bmp",
	guard_rail_with_reflectors_at_corners_curves_red_colour_white_colour: "images/PR_labelled_data_icons/road_sign_or_obstruction/guard_rail_with_reflectors_at_corners_curves_red_colour_white_colour.bmp",
	monorail: "images/PR_labelled_data_icons/road_sign_or_obstruction/monorail.bmp",
	street_parking: "images/PR_labelled_data_icons/road_sign_or_obstruction/street_parking.bmp",
	pavement_marker_reflector: "images/PR_labelled_data_icons/road_sign_or_obstruction/pavement_marker_reflector.bmp",
	metal_plate: "images/PR_labelled_data_icons/road_sign_or_obstruction/metal_plate.bmp",
	blinker_light: "images/PR_labelled_data_icons/bad_road_conditions/blinker_light.bmp",
	// rail_of_streetcar: "images/PR_labelled_data_icons/bad_road_conditions/rail_of_streetcar.bmp",
	grade_crossing: "images/PR_labelled_data_icons/bad_road_conditions/grade_crossing.bmp",

	//target_in_traffic 
	bicycle: "images/PR_labelled_data_icons/bad_road_conditions/bicycle.bmp",
	delivery_bike: "images/PR_labelled_data_icons/target_in_traffic/delivery_bike.bmp",
	group_motorcycle_2_or_more: "images/PR_labelled_data_icons/target_in_traffic/group_motorcycle_2_or_more.bmp",
	light_truck: "images/PR_labelled_data_icons/target_in_traffic/light_truck.bmp",
	low_floor_trailer: "images/PR_labelled_data_icons/target_in_traffic/low_floor_trailer.bmp",
	pedestrian: "images/PR_labelled_data_icons/target_in_traffic/pedestrian.bmp",
	sidecar: "images/PR_labelled_data_icons/target_in_traffic/sidecar.bmp",
	special_vehicle: "images/PR_labelled_data_icons/target_in_traffic/special_vehicle.bmp",
	taillamp_embedded: "images/PR_labelled_data_icons/target_in_traffic/taillamp_embedded.bmp",
	tow_vehicle: "images/PR_labelled_data_icons/target_in_traffic/tow_vehicle.bmp",
	trike: "images/PR_labelled_data_icons/target_in_traffic/trike.bmp",
	vehicle_with_spare_tire: "images/PR_labelled_data_icons/target_in_traffic/vehicle_with_spare_tire.bmp",
	long_vehicles: "images/PR_labelled_data_icons/target_in_traffic/long_vehicles.bmp",

	// "others" --> all mapped 
	// national_route_jp_road : "images/PR_labelled_data_icons/others/national_route_jp_road.bmp",
	// prefectural_roads_jp_road: "images/PR_labelled_data_icons/others/prefectural_roads_jp_road.bmp",
	// other_load_jp_road: "images/PR_labelled_data_icons/others/other_load_jp_road.bmp",
	// highway_entry : "images/PR_labelled_data_icons/others/highway_entry.bmp",
	// signs_on_the_street : "images/PR_labelled_data_icons/others/signs_on_the_street.bmp",
	// falling_object : "images/PR_labelled_data_icons/others/falling_object.bmp",
	// streetcar : "images/PR_labelled_data_icons/others/streetcar.bmp",
	// motorbike: "images/PR_labelled_data_icons/others/motorbike.bmp",
	// multi_storey_parking_start_end : "images/PR_labelled_data_icons/others/multi_storey_parking_start_end.bmp",
	// large_parking_lot : "images/PR_labelled_data_icons/others/large_parking_lot.bmp",
	// pedestrian_bridge : "images/PR_labelled_data_icons/others/pedestrian_bridge.bmp",
	// other_unusual_shaped_vehicles: "images/PR_labelled_data_icons/others/other_unusual_shaped_vehicles.bmp",
	// backlighting : "images/PR_labelled_data_icons/others/backlighting.bmp",
	// substation_or_power_station : "falimages/PR_labelled_data_icons/others/substation_or_power_station.bmp",
	// other_poor_visibility : "images/PR_labelled_data_icons/others/other_poor_visibility.bmp",
	// incident : "images/PR_labelled_data_icons/others/incident.bmp",
	// otherobject : "images/PR_labelled_data_icons/others/otherobject.bmp"
}

export const pgVisibleLabels = [
	"based_vehicle",
	"cmbs_software_version",
	"customization_information",
	"development_target",
	"ecu_software_version",
	"mandatory_target",
	"road_condition",
	"test_course",
	"test_location",
	"test_result",
	"test_scenario_validity",
	"test_vehicle",
	"weather",
]




